import {createListenerMiddleware} from "@reduxjs/toolkit";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";

/**
 * Listener that fetches user authentication status and profile after successful authentication.
 */
export const fetchUserDataAfterAuthListener = createListenerMiddleware<IRootState>();

fetchUserDataAfterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;

        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
            await listenerApi.dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true})).unwrap();
        } catch (error) {
            notifyBugsnag(error, "Failed to fetch user data after authentication", {
                ...pick(authPayload, ["type", "userSource", "registrationMethod"])
            });
        }
    }
});
import {createListenerMiddleware} from "@reduxjs/toolkit";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";

/**
 * Listener that fetches user authentication status and profile after successful authentication.
 */
export const fetchUserDataAfterAuthListener = createListenerMiddleware<IRootState>();

fetchUserDataAfterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;

        try {
            await listenerApi.dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
            await listenerApi.dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true})).unwrap();
        } catch (error) {
            notifyBugsnag(error, "Failed to fetch user data after authentication", {
                ...pick(authPayload, ["type", "userSource", "registrationMethod"])
            });
        }
    }
});
